<template>
  <div class="main-content">
    <div class="page-header">
      <h3 class="page-title">Productos</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">Productos</a>
        </li>
        <li class="breadcrumb-item active">Productos</li>
      </ol>
    </div>
    <div class="card">
      <div class="card-header">
        <button type="button" @click="openModal('register', '')" class="btn btn-theme">Nuevo</button>
      </div>
      <div class="card-body">
        <div class="form-group row">
          <div class="col-md-6">
            <div class="input-group">
              <select class="form-control col-md-4" v-model="critery">
                  <option value="name">Nombre del producto</option>
                  <option value="code">Código del producto</option>
              </select>
              <input type="text" v-model="search" @keyup="fetchData(1,search,critery, checkboxmanual, datosTienda)"  class="form-control" placeholder="Ingrese el nombre del producto">
              <button type="submit" @click="fetchData(1,search,critery, checkboxmanual, datosTienda)" class="btn btn-theme"><i class="icon-fa icon-fa-search"></i> Buscar</button>
            </div>
            <br>
            <div class="form-check">
              <input
                id="exampleRadios1"
                class="form-check-input"
                type="radio"
                name="exampleRadios"
                value="1"
                checked
                v-model="datosTienda"
                @change="fetchData(1, search, critery, checkboxmanual, datosTienda)"
              >
              <label class="form-check-label col md-3" for="exampleRadios1">
                La Colima H&A
              </label>
              <input
                id="exampleRadios2"
                class="form-check-input"
                type="radio"
                name="exampleRadios"
                value="2"
                v-model="datosTienda"
                @change="fetchData(1, search, critery, checkboxmanual, datosTienda)"
              >
              <label class="form-check-label col md-3" for="exampleRadios2">
                GÜICHO COLIMA
              </label>
              <input
                id="exampleRadios3"
                class="form-check-input"
                type="radio"
                name="exampleRadios"
                value="3"
                v-model="datosTienda"
                @change="fetchData(1, search, critery, checkboxmanual, datosTienda)"
              >
              <label class="form-check-label col md-3" for="exampleRadios3">
                DIOBER
              </label>
            </div>
            <br>
            <div class="custom-control custom-checkbox mb-3">
              <input
                id="customControlValidation1"
                type="checkbox"
                class="custom-control-input"
                v-model="checkboxmanual"
                required
                @change="fetchData(1, search, critery, checkboxmanual, datosTienda)"
              >
              <label v-if="checkboxmanual === false" class="custom-control-label" for="customControlValidation1">
                Mostrar datos inactivos
              </label>
              <label v-else class="custom-control-label" for="customControlValidation1">
                Mostrar datos activos
              </label>
              <div class="invalid-feedback">Example invalid feedback text</div>

            </div>

          </div>
        </div>
        <table class="table table-responsive">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Código</th>
              <th>Existencia</th>
              <th>Precio de costo</th>
              <th>Precio de venta</th>
              <th>Estado</th>
              <th>Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="stock in arrayProducts" :key="stock.id">
              <td v-text="stock.name"></td>
              <td v-text="stock.code"></td>
              <td v-text="stock.stock"></td>
              <td v-text="stock.total_cost"></td>
              <td v-text="stock.sales_price"></td>
              <td>
                <span v-if="stock.state==1" class="btn btn-success btn-sm">Para facturar</span>
                <span v-else-if="stock.state==2" class="btn btn-info btn-sm">No factura</span>
                <span v-else class="btn btn-danger btn-sm">Desactivado</span>
              </td>
              <td>
                <template>
                  <div
                    class="btn-group mr-2"
                    role="group"
                    aria-label="First group"
                  >
                    <button v-tooltip.top-center="'Editar producto'" class="btn btn-theme" @click="openModal('update', stock)"><i class="icon-fa icon-fa-pencil"/></button>
                    <!-- Preguntar si se deja editar y desactivar escrito o solo los iconos -->
                    <button v-tooltip.top-center="'Desactivar producto'" v-if="stock.state==1" class="btn btn-danger" @click="openModal('deactivate', stock)"><i class="icon-fa icon-fa-trash"/></button>
                    <button v-tooltip.top-center="'Activar producto'" v-else class="btn btn-info" @click="openModal('activate', stock)"><i class="icon-fa icon-fa-check"/></button>
                  </div>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
        <!--Paginación de tabla-->
        <div class="card">
            <div class="card-body">
                <ul class="pagination pagination-primary m-b-0">
                    <li class="page-item" v-if="pagination.current_page > 1">
                        <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page - 1, search, critery, checkboxmanual, datosTienda)"><i class="icon-fa icon-fa-angle-left"></i></a>
                    </li>
                    <li class="page-item" v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']">
                        <a class="page-link" href="#" @click.prevent="changePage(page, search, critery, checkboxmanual, datosTienda)" v-text="page"></a>
                    </li>
                    <li class="page-item" v-if="pagination.current_page < pagination.last_page">
                        <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page + 1, search, critery, checkboxmanual, datosTienda)"><i class="icon-fa icon-fa-angle-right"></i></a>
                    </li>
                </ul>
            </div>
        </div>
        <!-- Tabla maquetada por Arturo y Pedro-->
      </div>


      <!-- MODALES -->
      <!--Modal activar desactivar -->
      <sweet-modal ref="activar_modal" icon="info">
        {{titleModalActivate}}
        <button
          slot="button"
          type="button"
          class="btn btn-info"
          @click="$refs.activar_modal.close()"
        >
          No
        </button>
        <button
          slot="button"
          type="button"
          class="btn btn-danger"
          v-if="tipoAccion == 3"
          @click="deactivateProduct()"
        >
          Si
        </button>
        <button
          slot="button"
          type="button"
          class="btn btn-success"
          v-if="tipoAccion == 4"
          @click="activateProduct()"
        >
          Si
        </button>
      </sweet-modal>

      <!--Modal de productos general -->
      <sweet-modal ref="product_modal" :title="titleModal" width="75%" length="75%" hide-close-button blocking>
        <div class="card-body">
          <div class="form-group">
            <label>Nombre</label>
            <input
              ref="nameInput"
              :class="{ 'is-invalid': $v.name.$error }"
              v-model.trim="name"
              class="form-control"
              @input="$v.name.$touch()">
            <div v-if="$v.name.$error">
              <span v-if="!$v.name.required" class="help-block help-block-error">
                El campo es requerido
              </span>
            </div>
          </div>
          <div class="form-group">
            <label>Código</label>
            <input
              ref="nameInput"
              :class="{ 'is-invalid': $v.code.$error }"
              v-model.trim="code"
              class="form-control"
              @input="$v.code.$touch()">
            <div v-if="$v.code.$error">
              <span v-if="!$v.code.required" class="help-block help-block-error">
                El campo es requerido
              </span>
            </div>
          </div>
          <div class="form-group">
            <label>Existencia</label>
            <input
              ref="nameInput"
              :class="{ 'is-invalid': $v.stock.$error }"
              v-model.trim="stock"
              class="form-control"
              @input="$v.stock.$touch()">
            <div v-if="$v.stock.$error">
              <span v-if="!$v.stock.required" class="help-block help-block-error">
                El campo es requerido
              </span>
            </div>
          </div>
          <div class="form-group">
            <label>Estado de ingreso</label>
            <select v-model.trim="state" class="form-control">
              <option value="0">Seleccione el estado</option>
              <option value="1">Para facturar</option>
              <option value="2">No factura</option>
            </select>
            <div v-if="$v.state.$error">
              <span v-if="!$v.state.required" class="help-block help-block-error">
                El campo es requerido
              </span>
            </div>
          </div>
          <div class="form-group">
            <label>Precio de costo</label>
            <input
              ref="nameInput"
              :class="{ 'is-invalid': $v.total_cost.$error }"
              v-model.trim="total_cost"
              class="form-control"
              @input="$v.total_cost.$touch()">
            <div v-if="$v.total_cost.$error">
              <span v-if="!$v.total_cost.required" class="help-block help-block-error">
                El campo es requerido
              </span>
            </div>
          </div>
          <div class="form-group">
            <label>Precio de venta</label>
            <input
              ref="nameInput"
              :class="{ 'is-invalid': $v.sales_price.$error }"
              v-model.trim="sales_price"
              class="form-control"
              @input="$v.sales_price.$touch()">
            <div v-if="$v.sales_price.$error">
              <span v-if="!$v.sales_price.required" class="help-block help-block-error">
                El campo es requerido
              </span>
            </div>
          </div>
          <div class="form-group">
            <label>Precio de descuento</label>
            <input
              ref="nameInput"
              :class="{ 'is-invalid': $v.special_price.$error }"
              v-model.trim="special_price"
              class="form-control"
              @input="$v.special_price.$touch()">
            <div v-if="$v.special_price.$error">
              <span v-if="!$v.special_price.required" class="help-block help-block-error">
                El campo es requerido
              </span>
            </div>
          </div>
          <div class="form-group">
            <label>Tienda</label>
            <select v-model.trim="idplace" class="form-control">
              <option value="0">Seleccione la tienda</option>
              <option
                v-for="place in arrayPlaces"
                :key="place.id"
                :value="place.id"
                v-text="place.name"
              />
            </select>
            <div v-if="$v.state.$error">
              <span v-if="!$v.state.required" class="help-block help-block-error">
                El campo es requerido
              </span>
            </div>
          </div>
        </div>

        <!-- icons is an object containing SVG strings -->
        <button slot="button" type="button" class="btn btn-danger" @click="closeModal()">Cancelar</button>
        <button
          slot="button"
          type="button"
          class="btn btn-primary ladda-button"
          data-style="expand-right"
          v-if="tipoAccion == 1"
          @click="saveProduct()"
        >Guardar</button>
        <button
          slot="button"
          type="button"
          class="btn btn-primary ladda-button"
          data-style="expand-right"
          v-if="tipoAccion == 2"
          @click="updateProduct()"
        >Actualizar</button>
      </sweet-modal>

    </div>
  </div>
</template>

<script>

import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import Multiselect from 'vue-multiselect';
import { required, sameAs, minLength, between } from "vuelidate/lib/validators";
import ladda from "ladda";
import { Tabs, Tab } from 'vue-tabs-component';

export default {
  components: {
    SweetModal,
    SweetModalTab,
    Multiselect,
    'tabs': Tabs,
    'tab': Tab
  },
  data() {
    return {
      checkboxmanual: false,
      datosTienda: "1",
      titleModal: "",
      name: "",
      code: "",
      stock: 0,
      low_stock: 0,
      location: "",
      state: 0,
      purchase_price: 0.0,
      sales_price: 0.0,
      special_price: 0.0,
      total_cost: 0.0,
      idplace: 0,
      id: 0,
      tipoAccion: 1,
      titleModalActivate: '',
      arrayProducts: [],
      arrayPlaces: [],
      arrayStockP: [],
      pagination : {
          'total' : 0,
          'current_page' : 0,
          'per_page' : 0,
          'last_page' : 0,
          'from' : 0,
          'to' : 0,
      },
      offset : 3,
      critery : 'name',
      search : '',
      isLoading: false,
    };
  },
  install(Vue, options) {
    Vue.component("SweetModal", SweetModal);
    Vue.component("SweetModalTab", SweetModalTab);
  },
  validations() {
      return{
        name: {
          required,
        },
        code: {
          required,
        },
        stock: {
          required,
        },
        low_stock: {
          required,
        },
        state: {
          required,
        },
        total_cost: {
          required,
        },
        sales_price: {
          required,
        },
        special_price: {
          required,
        },
        idplace: {
          required,
        },
      }
  },
  computed:{
    isActived : function(){
        return this.pagination.current_page;
    },
    pagesNumber : function(){
        if(!this.pagination.to){
            return [];
        }
        var from = this.pagination.current_page - this.offset;
        if(from < 1){
            from = 1;
        }
        var to = from + (this.offset * 2);
        if(to >= this.pagination.last_page)
        {
            to = this.pagination.last_page;
        }
        var pagesArray = [];
        while(from <= to){
            pagesArray.push(from);
            from++;
        }
        return pagesArray;
    },
  },
  methods: {
    changePage(page,search,critery, checkboxmanual, datosTienda){
        let me = this;
        //Actualiza la página actual
        me.pagination.current_page = page;
        //Envia la petición para visualizar la data de esa página
        me.fetchData(page,search,critery, checkboxmanual,datosTienda);
    },
    async fetchData(page, search, critery, checkboxmanual, datosTienda) {
      let me = this;
      const response = await axios.get(
        `/api/admin/stock/get?page=${page}&search=${search}&critery=${critery}&checkboxmanual=${checkboxmanual}&datosTienda=${datosTienda}`)
      .then(function (response) {
        var respuesta= response.data;
        me.arrayProducts = respuesta.stocks.data;
        me.pagination= respuesta.pagination;
      })
      .catch(function (error) {
          console.log(error);
      });
    },

    saveProduct() {
      console.log('estamos aqui')
      var l = ladda.create(document.querySelector(".ladda-button"));
      this.$v.$touch();
      let me = this;
      if (this.$v.$invalid) {
        toastr.error("Revise los campos", "Error");
      }
      else {
        l.start();
        axios
          .post("/api/admin/stock/", {
            name: this.name,
            code: this.code,
            stock: this.stock,
            total_cost: this.total_cost,
            low_stock: this.low_stock,
            location: this.location,
            state: this.state,
            purchase_price: this.purchase_price,
            sales_price: this.sales_price,
            total_cost: this.total_cost,
            special_price: this.special_price,
            idplace: this.idplace,
          })
          .then(function(response) {
            if(response.data.message != 'El nombre del producto ya existe en nuestros registros.'){
              toastr.success('Producto guardado exitosamente', "Listo");
              l.stop();
              me.closeModal();
            }
            else{
              toastr.error(response.data.message, "Error");
            }

          })
          .catch(function(error) {
            l.stop();
            toastr.error(error.response.data.message, "Error");
          });
      }
    },
    updateProduct() {
      var l = ladda.create(document.querySelector(".ladda-button"));
      this.$v.$touch();
      let me = this;
      if (this.$v.$invalid) {
        console.log(this.$v)
        toastr.error("Revise los campos", "Error");
      } else {
        l.start();
        axios
          .put("/api/admin/stock/update", {
            name: this.name,
            code: this.code,
            stock: this.stock,
            low_stock: this.low_stock,
            location: this.location,
            total_cost: this.total_cost,
            state: this.state,
            purchase_price: this.purchase_price,
            sales_price: this.sales_price,
            total_cost: this.total_cost,
            special_price: this.special_price,
            idplace: this.idplace,
            id: this.id
          })
          .then(function(response) {
            toastr.success(response.data.message, "Listo");
            l.stop();
            me.closeModal();
          })
          .catch(function(error) {
            l.stop();
            toastr.error(error.response.data.message, "Error");
          });
      }
    },
    activateProduct() {
      let me = this
      axios.put('/api/admin/stock/activate', {
        id: this.id
      })
      .then(function (response) {
        toastr.success(response.data.message, 'Listo')
        me.closeModal()
      })
      .catch(function (error) {
        toastr.error(error.response.data.message, 'Error')
      });
    },
    deactivateProduct() {
      let me = this
      axios.put('/api/admin/stock/deactivate', {
        id: this.id
      })
      .then(function (response) {
        toastr.success(response.data.message, 'Listo')
        me.closeModal()
      })
      .catch(function (error) {
        toastr.error(error.response.data.message, 'Error')
      });
    },
    openModal(accion, data = []) {
      let me = this;
      switch (accion) {
        case "register": {
          me.$refs.product_modal.open();
          this.titleModal = "Nuevo Producto";
          this.name = "";
          this.code = "";
          this.stock = 0;
          this.low_stock = 0;
          this.location = "";
          this.state = 0;
          this.total_cost = 0.0;
          this.purchase_price = 0.0;
          this.sales_price = 0.0;
          this.special_price = 0.0;
          this.idplace = 0;
          this.tipoAccion = 1;
          break;
        }
        case "update": {
          me.$refs.product_modal.open();
          this.titleModal = "Actualizar Producto";
          this.name = data["name"];
          this.code = data["code"];
          this.stock = data["stock"];
          this.low_stock = data["low_stock"];
          this.location = data["location"];
          this.state = data["state"];
          this.purchase_price = data["purchase_price"];
          this.sales_price = data["sales_price"];
          this.total_cost = data["total_cost"];
          this.special_price = data["special_price"];
          this.idplace = data["idplace"];
          this.id = data["id"];
          this.tipoAccion = 2;
          break;
        }
        case 'deactivate':
        {
          me.$refs.activar_modal.open()
          this.titleModalActivate = '¿Desea desactivar el producto?'
          this.id = data['id']
          this.tipoAccion = 3
          break;
        }
        case 'activate':
        {
          me.$refs.activar_modal.open()
          this.titleModalActivate = '¿Desea activar el producto?'
          this.id = data.id
          this.tipoAccion = 4
          break;
        }
      }
    },
    closeModal() {
      this.$refs.product_modal.close();
      this.name = "";
      this.code = "";
      this.stock = 0;
      this.low_stock = 0;
      this.location = "";
      this.state = 0;
      this.purchase_price = 0.0;
      this.sales_price = 0.0;
      this.total_cost = 0.0;
      this.special_price = 0.0;
      this.idplace = 0;
      this.titleModal = "";
      this.titleModalActivate = '';
      this.$refs.activar_modal.close();
      this.$v.$reset();
      this.fetchData(this.pagination.current_page, this.search, this.critery, this.checkboxmanual, this.datosTienda);
    },
    selectPlace(filter){
        let me=this;
        var url = `/api/admin/place/getSelect`;
        this.isLoading = true
        axios.get(url).then(function (response){
          var respuesta = response.data;
          me.isLoading = false
          me.arrayPlaces = respuesta.place
        })
        .catch(function(error){
            console.log(error);
        });
    },
  },
  mounted(){
    this.selectPlace();
    this.fetchData(1, this.search, this.critery, this.checkboxmanual, this.datosTienda);
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/views/admin/products/Products.vue